module.exports = __webpack_public_path__ + "img/Paychex.da217dc6.svg";